import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import App from './App';
import { getShowSidebar } from 'store/sidebar/selectors';
import { getPersistentSidebar } from '../../store/browser/selectors';

const mapStateToProps = createSelector(
  getShowSidebar,
  getPersistentSidebar,
  (showSidebar, persistentSidebar) => ({
    showSidebar, persistentSidebar
  })
);

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js